module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-06.fee34741.png";